import { NewComponent } from "../components";
import { connect } from "react-redux";
import { GetDataEmailAction, GetDataNewPlanTemplateAction, SetDataNewPlanTemplateAction } from "../actions";

const mapStateToProps = state => {
    return {
        ...state,
        DataNew: state.allPlanTemplateReducers.newAllReducers.newReducer.DataNew,
        DataEmail: state.allPlanTemplateReducers.newAllReducers.emailReducer.DataEmail,
        isResult: state.allPlanTemplateReducers.isResultReducer.isResult
    };
};

const mapDispatchToProps = dispatch => {
    return {
        GetDataNew: (id) => {
            dispatch(GetDataNewPlanTemplateAction(id));
        },
        SetDataNew: (DataNew) => {
            dispatch(SetDataNewPlanTemplateAction(DataNew));
        },
        GetDataEmail: () =>{
            dispatch(GetDataEmailAction());
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(NewComponent);